export const ENTITY_LABEL = "Object";

export const ENTITY_PLURAL_LABEL = "Objects";